import pkg from '../../package.json';

export const environment = {
  production: true,
  appId: 'at61REtRkMR5sDfshg6t',
  productName: 'VPBX',
  companyName: 'Gintel',
  companyUrl: 'http://www.gintel.no',
  companyUrlDisplay: 'gintel.no',
  wsUrl: 'wss://demo.gintel.com/ServiceGateway/websockets/events',
  apiUrl: 'https://demo.gintel.com/ServiceGateway/rest',
  SIPwsURL: '',
  vccUrl: '',
  customerServiceUrl: 'https://www.gintel.com/about/support/',
  selfHelpUrl: 'https://www.gintel.com/',
  mapUrl: 'https://kart.gulesider.no/s/', // https://kart.1881.no/?query= https://www.google.no/maps/place/
  exchangeUrl: 'https://outlook.office365.com/EWS/Exchange.asmx',
  o365loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
  o365clientIdCalendar: '',
  o365clientIdDirectory: '',
  o365clientIdPresence: '',
  version: pkg.version,
  languages: ['en-GB', 'de-DE'],
  allowedDisplayNumberPatterns: ['1'],
  allowedForwardingPatterns: ['1', '2'],
  allowedCallLogPatterns: ['2'],
  allowedDirectoryPatterns: ['1', '2'],
  allowedVisibleNumberPatterns: ['1'],
  answerGroupPattern: '2',
  mainNumberPattern: '1',
  menuPattern: '7',
  vipListPattern: '9',
  hasGenericNumberExpressionModePrefix: true,
  hasGenericNumberExpressionModePostfix: true,
  genericDisplayNumberPostfixModeA: 'G',
  genericDisplayNumberPostfixModeB: 'B',
  genericDisplayNumberPrefixModeA: 'G',
  genericDisplayNumberPrefixModeB: 'B',
  genericDisplayNumberMinLength: 2,
  genericDisplayNumberMaxLength: 3,
  genericDisplayNumberPrefixPadding: '11113',
  genericDisplayNumberDeactivatedValue: null,
  muteCallNotifications: false,
  noAccessRedirectRoute: 'noaccess',
  noAdminAccessRedirectRoute: 'noaccess',
  noSwbAccessRedirectRoute: 'noaccess',
  phoneNumberFormatLocalization: 'NO',
  postLoginRedirectRouteServiceProvider: 'swb',
  postLoginRedirectRoute: 'user',
  postLoginRedirectAdminAndSwb: 'admin',
  postLoginRedirectAdmin: 'admin',
  postLoginSwb: 'swb',
  postLoginRedirectRouteMobile: 'user',
  queuePauseTime: 40,
  requireTrigging: true,
  hasUnavailableReasons: false,
  callBackQueuesCid: [],
  hasPrivateNumber: true,
  hasOutsideOfWorkingHours: true,
  hasDepartments: false,
  hasVcc: false,
  hasAdmin: true,
  useWebsocket: false,
  useLongPolling: true,
  useXmlPush: true,
  pollingTimeout: 60000,
  maxTimeSinceLastPollSuccess: 120000,
  hasSmsNps: true,
  hasMaxPositionsOptions: true,
  hasMaxKickoutTimeOptions: true,
  hasMaxTimeOptions: true,
  hasShowHuntTypes: true,
  hasHideStatistics: false,
  hasCompanySettingsTab: false,
  hasCompanySettings: false,
  hasCompanyWorkingHours: false,
  hasInternationalForwardingWhiteList: true,
  hasCompanyBlackWhiteList: false,
  hasServiceProviderNumberLookup: false,
  hasServiceProviderMicrosoftSync: false,
  hasServiceProviderCtiPush: false,
  hasCTIPush: false,
  hasShareContact: true,
  hasShowDisplayNumberOption: true,
  hasShowShortNumber: true,
  hasShowDeleteEmployee: false,
  hasRecordAnnouncement: false,
  recordAnnouncementNumber: '',
  hasDeleteAnswerGroupBtn: true,
  hasWallboardAutoScroll: false,
  outsideOpeningHoursCidsToRemove: [25],
  outsideOpeningHoursCidsToAdd: [60],
  unansweredCallsCidsToRemove: [30],
  unansweredCallsCidsToAdd: [24, 31, 60],
  hasUserSettings: true,
  hasShowDisplayExpression: false,
  hasQueueAlarms: false,
  hasForgotPasswordButton: false,
  hasEditAnswerGroupLogin: true,
  noReplyTime: [0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90],
  wrapupTime: [0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90],
  hasDragAndDropSkillEditor: true,
  hasLoggedInEmployeeSwitch: true,
  hasUseFixedLineNumber: false,
  hasServiceProvider: false,
  hasServiceProviderCompanyFeatureToggle: false,
  userSearchColumns: ['organization', 'number', 'short-number', 'type', 'name', 'actions'],
  hasAdminMainNumbersPage: false,
  hasCallback: false,
  hasCallbackSmsNotification: false,
  hasTransferMissedCalls: true,
  showBreadcrumbs: false,
  hasBlockOutgoingOption: false,
  hasShowQueueDisplayNumber: false,
  enableSentry: false,
  enableSentryReportDialog: false,
  sentryReleaseName: 'vpbx',
  newSwitchboardLink: '',
  sentryEnvironment: 'dev',
  serviceProviderNewEndUserDefaultTriggering: false,
  serviceProviderNewEndUserNationalNumberLoginFormat: true,
  allowEUEventsFromQueue: false,
  canForwardToExternalNumbers: false
};
